import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async';

function ServiceDetail2() {
  return (
    <>
    <Helmet>
    <title>
        Customised Electrical Enclosure Solutions UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides customised electrical and electronic enclosure solutions in the UAE using Polycarbonate, ABS, GRP and metal materials, with EMC protection, wiring, junction boxes, control stations and push button solutions."
    />

    <meta
        name="keywords"
        content="customised enclosure solutions UAE, electrical enclosures UAE, electronic enclosures UAE, custom electrical enclosure UAE, Polycarbonate enclosures UAE, ABS enclosures UAE, GRP enclosures UAE, metal enclosures UAE, EMC protection UAE, junction boxes UAE, control stations UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/customised-enclosure-solutions"
    />

    <meta
        property="og:title"
        content="Customised Electrical Enclosure Solutions UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Customised electrical and electronic enclosures with EMC protection, wiring, junction boxes, control stations and push button solutions for demanding industrial applications."
    />

    <meta
        property="og:url"
        content="https://saig.me/customised-enclosure-solutions"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
      <div className='newbanner-about newbanner-about2'>
        <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
          <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Customised Enclosure<br /> Solutions</h6>
          {/* <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Smart, Safe, and Field-Tested Solutions — All in One Place. */}
          {/* </p> */}
        </div>
      </div>
         <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Customised Enclosure Solutions</h2>
  <div className='line'></div>
                         <h3 className='text-left'>We specialize in offering high-quality, customized electrical and electronic enclosure solutions that meet the specific needs of demanding industrial environments. Our enclosures are available in various durable materials such as Polycarbonate, ABS, GRP, and metals, ensuring optimal protection, longevity, and performance across diverse applications. From providing EMC (Electromagnetic Compatibility) Protection to advanced Socket Combination Boxes, we integrate solutions that not only protect sensitive components but also enhance system functionality. Our services include complete Wiring & Installation, Emergency Push Button units for safety-critical areas, and reliable Terminal Junction Boxes for efficient cable management. We also design and deliver Control Stations and Push Button Stations that are user-friendly, robust, and compliant with industry standards. Whether for industrial automation, process control, or safety applications, our tailored enclosures and integration capabilities are engineered to deliver precision, reliability, and maximum protection.
         </h3>

               </div>
               </div>
      <div className='service-details-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[80px]'>
        <div className='service-details-div-left'>
          <img src='/assets/newsr6.png' alt='hello' />
        </div>
        <div className='service-details-div-right font-kanit'>
          {/* <h2>Customised Enclosure Solutions</h2>
          <h3>We specialize in offering high-quality, customized electrical and electronic enclosure solutions that meet the specific needs of demanding industrial environments. Our enclosures are available in various durable materials such as Polycarbonate, ABS, GRP, and metals, ensuring optimal protection, longevity, and performance across diverse applications. From providing EMC (Electromagnetic Compatibility) Protection to advanced Socket Combination Boxes, we integrate solutions that not only protect sensitive components but also enhance system functionality. Our services include complete Wiring & Installation, Emergency Push Button units for safety-critical areas, and reliable Terminal Junction Boxes for efficient cable management. We also design and deliver Control Stations and Push Button Stations that are user-friendly, robust, and compliant with industry standards. Whether for industrial automation, process control, or safety applications, our tailored enclosures and integration capabilities are engineered to deliver precision, reliability, and maximum protection.
          </h3>
          <br /> */}
         <div className="service-details-div2 font-kanit service-details-div2-new">

  {/* ITEM */}
  <div className="service-heading">
    <span className="dot">●</span>
    <h4>EMC (Electromagnetic Compatibility) Protection</h4>
  </div>
  <p>
    EMC protection ensures that electrical and electronic devices operate without interference from or to other equipment. Our enclosures are designed with shielding and grounding provisions to minimize electromagnetic disturbances, making them ideal for sensitive control and communication systems.
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Socket Combination Boxes</h4>
  </div>
  <p>
    These are customizable power distribution units that combine multiple socket outlets in a single enclosure. Commonly used on industrial sites, they offer flexible, safe, and organized power access for machines, tools, and temporary setups.
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Wiring & Installation</h4>
  </div>
  <p>
    We provide complete internal wiring and component installation within the enclosures as per the client’s specifications.
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Emergency Push Button</h4>
  </div>
  <p>
    Designed for safety-critical applications, these buttons allow users to immediately shut down equipment or stop processes during emergencies.
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Terminal Junction Boxes</h4>
  </div>
  <p>
    These boxes provide a secure and organized environment for connecting and protecting electrical wires.
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Control Stations</h4>
  </div>
  <p>
    Control stations house switches, indicators, and operator controls in a compact and durable enclosure.
  </p>

  <div className="service-heading">
    <span className="dot">●</span>
    <h4>Push Button Stations</h4>
  </div>
  <p>
    These are enclosures equipped with one or more push buttons to control machinery or systems.
  </p>

  <Link to="/services">
    <button className="backbtn">Back To Services</button>
  </Link>

</div>

        </div>
      </div>

    </>
  )
}

export default ServiceDetail2